import { Cursor } from '@studiometa/ui';

/**
 * Custom Cursor that shows the label only when hovering cards.
 */
export default class CardCursor extends Cursor {
  static config = {
    ...Cursor.config,
    name: 'CardCursor',
    refs: ['label'],
    options: {
      ...Cursor.config.options,
      cardSelectors: {
        type: String,
        default: '.deck, .deck *, [data-component="Card"], [data-component="Card"] *',
      },
    },
  };

  /**
   * Track hover state.
   * @type {boolean}
   */
  isHoveringCard = false;

  /**
   * Get the label element.
   * @returns {HTMLElement|null}
   */
  get label() {
    const label = this.$refs.label;
    return Array.isArray(label) ? label[0] : label;
  }

  /**
   * Check if the hovered card is already revealed.
   * @param {Element} target
   * @returns {boolean}
   */
  isCardRevealed(target) {
    const card = target.closest('[data-component="Card"]');
    return card ? card.classList.contains('is-active') : false;
  }

  /**
   * Mounted hook.
   */
  mounted() {
    super.mounted();
    this.x = window.innerWidth / 2;
    this.y = window.innerHeight / 2;
    this.pointerX = this.x;
    this.pointerY = this.y;
    this.render({ x: this.x, y: this.y, scale: this.scale });
  }

  /**
   * Moved hook - show label only when hovering cards that are not revealed.
   * @param {object} props
   */
  moved(props) {
    super.moved(props);
    this.$el.classList.remove('opacity-0');

    const { event } = props;
    const label = this.label;

    if (!event || !label) {
      return;
    }

    const isHoveringCard =
      event.target instanceof Element &&
      event.target.matches(this.$options.cardSelectors) &&
      !this.isCardRevealed(event.target);

    if (isHoveringCard !== this.isHoveringCard) {
      this.isHoveringCard = isHoveringCard;
      label.classList.toggle('opacity-0', !isHoveringCard);
      label.classList.toggle('scale-0', !isHoveringCard);
      label.classList.toggle('opacity-100', isHoveringCard);
      label.classList.toggle('scale-100', isHoveringCard);
    }
  }
}
